var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"home-title flex-row items-center"},[_c('span',{staticClass:"home-title-text"},[_vm._v(_vm._s(_vm.txt))]),(_vm.toMore)?[_c('MoreVue',{attrs:{"to":_vm.toMore}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }